import * as React from 'react';

import type { AiAskIndexData } from '../../utils/aiAskHelpers';
import { flattenSearchOnlyHits } from '../../utils/messageBuilders';
import { HitPreviewList } from './HitPreviewList';

export const SearchOnlyResultsBlock: React.FC<{
  results: unknown[];
  indexData?: AiAskIndexData;
}> = ({ results, indexData }) => {
  const hits = flattenSearchOnlyHits(results);
  return <HitPreviewList hits={hits} indexData={indexData} />;
};
